import AdminOperationsScreen from "../../src/features/arrangements/screens/AdminOperationsScreen";

export default function FormTemplateLibraryRoute() {
  return <AdminOperationsScreen screenIdOverride="form-template-library" />;
}
